'use client'

import { useAction } from 'next-safe-action/hooks'

import { updateGuestContractDepositReturnAccount } from '@/entities/contract'
import { TAccountFormValues } from '@/features/update-account'
import { useServerErrorHandler } from '@/shared/config'

import { convertFormValuesToDepositReturnAccount } from '../model/converter'

type Props = {
  onSuccess?: () => void
}

export const useUpdateGuestContractDepositReturnAccount = ({
  onSuccess,
}: Props) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(updateGuestContractDepositReturnAccount, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const updateDepositReturnAccount = (
    contractId: number,
    formValues: TAccountFormValues,
  ) => {
    if (!contractId) {
      return
    }

    const depositReturnAccount =
      convertFormValuesToDepositReturnAccount(formValues)

    action.execute({
      contractId: Number(contractId),
      body: {
        depositReturnAccount,
      },
    })
  }

  return { action, updateDepositReturnAccount }
}
